<script>
    import Conexoes from "../../Classes/Conexoes";
    import Constantes from "../../Classes/Constantes";
    import DropSelecao from "../../componentes_basicos/DropSelecao.svelte";
    import LoadingTela from "../../componentes_basicos/LoadingTela.svelte";
    import Anamneses from "./Anamneses.svelte";
    import { ItemInserir, Tipo } from "../../Classes/ItemInserir.js";
    import InserirDadosBasico from "../../Componentes/InsercaoDados/InserirDadosBasico.svelte";
    import AlteraDadosBasico from "../../Componentes/AlteracaoDados/AlteraDadosBasico.svelte";
    import { onMount } from "svelte";

    export let id_usuario = 0;
    export let id_assessoria = 0;
    const conexao = new Conexoes();
    let resultado = [];
    let isLoading = false;
    async function PegaDados() {
        isLoading = true;
        resultado = await conexao.conecta(Constantes.api_consultar_padrao, {
            query_code:
                Constantes.query_code_consulta_usuarios_metas_zonas_usuario,
            id_usuario: id_usuario,
            id_assessoria: id_assessoria,
        });
        isLoading = false;
        console.log("zonas ", resultado);
    }
    onMount(() => PegaDados());
</script>

<br />
<br />
<br />
<br />
{#if resultado.length > 0}
    <div class="alert alert-info mt-4" role="alert">
        <div class="resultado mt-4">
            <div class="card p-4 shadow-sm">
                <h2 class="card-title text-center mb-4">Paces Sugeridos:</h2>
                <ul class="list-group">
                    {#if resultado[0].pace_z1}
                        <li class="list-group-item">
                            Z1: <strong>{resultado[0].pace_z1}</strong> min/km
                        </li>
                    {/if}
                    {#if resultado[0].pace_z2}
                        <li class="list-group-item">
                            Z2: <strong>{resultado[0].pace_z2}</strong> min/km
                        </li>
                    {/if}
                    {#if resultado[0].pace_z3}
                        <li class="list-group-item">
                            Z3: <strong>{resultado[0].pace_z3}</strong> min/km
                        </li>
                    {/if}
                    {#if resultado[0].pace_z4}
                        <li class="list-group-item">
                            Z4: <strong>{resultado[0].pace_z4}</strong> min/km
                        </li>
                    {/if}
                    {#if resultado[0].pace_z5}
                        <li class="list-group-item">
                            Z5: <strong>{resultado[0].pace_z5}</strong> min/km
                        </li>
                    {/if}
                </ul>
            </div>
        </div>
    </div>

    <br />
    <br />
    <br />
    <br />
{/if}
